<div class="fixed fill grow white-bg z6 top">
  <header class="desktop-header dn-tablet-down border-bottom flex flex--middle nordic-blue-900-border">
    <fcom-icon
      class="finnair-blue nordic-blue-900-text ms-large-l"
      [category]="IconLibrary.CUSTOM"
      [name]="CustomIcon.FINNAIR_LOGO"
    ></fcom-icon>
    <fcom-icon class="icon-medium ms-large-l" [name]="SvgLibraryIcon.ONEWORLD_LOGO"></fcom-icon>
  </header>
  <header class="mobile-header dn-tablet-up border-bottom flex flex--center">
    <fcom-icon class="finnair-emblem" [category]="IconLibrary.CUSTOM" [name]="CustomIcon.FINNAIR_EMBLEM"></fcom-icon>
  </header>
  <div class="flex flex--column flex--center ps-large">
    <div class="ms-xlarge-b ms-xxlarge-t">
      <fcom-loader [loaderType]="LoaderTheme.INLINE_TEXT"></fcom-loader>
    </div>
    <h2 class="font-heading-2 align-center ms-xlarge-b">
      {{ 'CORPORATE.corporatePortal.redirectingToPartnerSite' | finLocalization }}
    </h2>
    <div class="font-body-2 medium-type align-center">
      {{ 'CORPORATE.corporatePortal.redirectDescription' | finLocalization }}
    </div>
  </div>
</div>
